import { createContext, ReactNode, useContext, useMemo, useState } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'

type CompactNavigationState = {
  isCompact: boolean
  drawerOpen: boolean
  toggleDrawer: () => void
  closeDrawer: () => void
}

const CompactNavigationContext = createContext<CompactNavigationState>({
  isCompact: false,
  drawerOpen: false,
  toggleDrawer: () => {},
  closeDrawer: () => {},
})

export const CompactNavigationProvider = ({ children }: { children: ReactNode }) => {
  const theme = useTheme()
  const isCompact = useMediaQuery(theme.breakpoints.down('md'))
  const [drawerOpen, setDrawerOpen] = useState(false)

  const value = useMemo(
    () => ({
      isCompact,
      drawerOpen: isCompact && drawerOpen,
      toggleDrawer: () => setDrawerOpen((prev) => !prev),
      closeDrawer: () => setDrawerOpen(false),
    }),
    [isCompact, drawerOpen]
  )

  return <CompactNavigationContext.Provider value={value}>{children}</CompactNavigationContext.Provider>
}

export const useCompactNavigation = () => useContext(CompactNavigationContext)
